import { gql } from '../../__generated__/gql'

export const COMMUNITY_CONSOLIDATED_NOTIFICATION_MARK_ALL_READ_MUTATION = gql(`
  mutation communityConsolidatedNotificationsMarkAllRead {
    communityConsolidatedNotificationsMarkAllRead(input: {}) {
     clientMutationId
    }
  }
`)
